import * as React from "react";
import { useEffect } from "react";
import { RouteComponentProps } from "react-router-dom";
import { URLS, useSocialCoachSession } from "@/utils";

export const LogoutPage: React.FC<RouteComponentProps> = ({ history }) => {
  const { logout } = useSocialCoachSession();

  useEffect(() => {
    const handleLogout = async () => {
      await logout();
      history.push(URLS.login);
    };

    handleLogout();
  }, [history, logout]);

  return (
    <div className="h-dvh w-full flex items-center justify-center bg-slate-50">
      <div className="flex flex-col items-center gap-3">
        {/* Subtle, standard loading spinner */}
        <div className="h-8 w-8 rounded-full border-4 border-slate-200 border-t-primary animate-spin" />
        <span className="text-sm font-semibold text-slate-500">Signing out...</span>
      </div>
    </div>
  );
};

export default LogoutPage;
